import { useEffect, useRef, useState } from "react"
import {
   getNow,
   isTimeMachineEnabled,
   resetTimeMachine,
   setNow,
   setTimeMachineEnabled,
} from "../../contexts/TimeMachineContext"

export function TimeMachine() {
   const now = getNow()
   const dateRef = useRef<HTMLInputElement>(null)
   const timeRef = useRef<HTMLInputElement>(null)
   const [enabled, setEnabled] = useState(isTimeMachineEnabled())
   const [, forceUpdate] = useState({})

   useEffect(() => {
      const handleTimeUpdate = () => {
         const now = getNow()
         if (dateRef.current) {
            dateRef.current.value = now.toISOString().split("T")[0]
         }
         if (timeRef.current) {
            timeRef.current.value = now
               .toTimeString()
               .split(" ")[0]
               .split(":")
               .slice(0, 2)
               .join(":")
         }
         setEnabled(isTimeMachineEnabled())
         forceUpdate({})
      }

      window.addEventListener("time-machine-update", handleTimeUpdate)
      return () => window.removeEventListener("time-machine-update", handleTimeUpdate)
   }, [])

   const handleSet = () => {
      const date = dateRef.current?.value
      const time = timeRef.current?.value
      if (!date || !time) return

      const [year, month, day] = date.split("-").map(Number)
      const [hours, minutes] = time.split(":").map(Number)
      const newDate = new Date(year, month - 1, day, hours, minutes)
      setNow(newDate)
   }

   const handleReset = () => {
      resetTimeMachine()
   }

   const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
      setTimeMachineEnabled(e.target.checked)
   }

   if (import.meta.env.VITE_ENVIRONMENT === "production") return null
   if (import.meta.env.VITE_DEV_SHOW_TIMEMACHINE_SETTER === "false") return null

   return (
      <>
         <div className="fixed top-0 left-0 right-0 bg-base-300 shadow-lg z-50">
            <div className="container mx-auto px-4 py-2 flex items-center gap-4">
               <label className="flex items-center gap-2 cursor-pointer">
                  <input
                     type="checkbox"
                     className="checkbox checkbox-sm"
                     checked={enabled}
                     onChange={handleToggle}
                  />
                  <span className="text-sm">Time Machine</span>
               </label>
               <input
                  ref={dateRef}
                  type="date"
                  className="input input-bordered input-sm"
                  defaultValue={now.toISOString().split("T")[0]}
                  onChange={handleSet}
                  disabled={!enabled}
               />
               <input
                  ref={timeRef}
                  type="time"
                  className="input input-bordered input-sm"
                  defaultValue={now.toTimeString().split(" ")[0].split(":").slice(0, 2).join(":")}
                  onChange={handleSet}
                  disabled={!enabled}
               />
               <button className="btn btn-ghost btn-sm" onClick={handleReset} disabled={!enabled}>
                  Reset
               </button>
            </div>
         </div>
         <div className="mt-12"></div>
      </>
   )
}
